import React from "react";
import "./sendbutton.css";
import { Button } from "antd";

const sendEmail = (email_addr, url, changes, confirmHandler) => {
  //Email validation is from: http://webcheatsheet.com/javascript/form_validation.php#phone
  var emailFilter = /^[^@]+@[^@.]+\.[^@]*\w\w$/;
  var illegalChars = /[()<>,;:\\"[]]/;

  if (email_addr === "") {
    return confirmHandler("warning", "You did not enter an email address");
  } else if (!emailFilter.test(email_addr)) {
    //test email for illegal characters
    return confirmHandler("warning", "Please enter a valid email address.");
  } else if (email_addr.match(illegalChars)) {
    return confirmHandler(
      "warning",
      "The email address contains illegal characters."
    );
    }

  return fetch("https://api.medbase.xyz/sendpills/mail", {
    method: "POST",
    mode: "cors",
    body: JSON.stringify({
      url: url,
      email_addr: email_addr,
      changes: changes,
    }),
    headers: {
      "Content-Type": "application/json"
    }
  })
    .then(res => {
      confirmHandler(
        "success",
        "Pill cards sent! Arrives in the next 15 minutes."
      );
    })
    .catch(err => {
      confirmHandler("warning", "Unable to send Pill cards. Check your input.");
    });
};

const sendText = (recipient, url, changes, confirmHandler) => {
  //Phone validation is from: http://webcheatsheet.com/javascript/form_validation.php#phone
  if (recipient === "") {
    return confirmHandler("warning", "You did not enter a phone number.");
  } else if (isNaN(parseInt(recipient))) {
    return confirmHandler(
      "warning",
      "The phone number contains illegal characters."
    );
  } else if (!(recipient.length === 10)) {
    return confirmHandler("warning", "The phone number is the wrong length.");
  }

  return fetch("https://api.medbase.xyz/sendpills/text", {
    method: "POST",
    mode: "cors",
    body: JSON.stringify({
      url: url,
      recipient: `1${recipient}`,
      changes: changes,
    }),
    headers: {
      "Content-Type": "application/json"
    }
  })
    .then(res => {
      confirmHandler(
        "success",
        "Pill cards sent! Arrives in the next 15 minutes."
      );
      return console.log(res);
    })
    .catch(err => {
      confirmHandler("warning", "Unable to send Pill cards. Check your input.");
      console.log(err);
    });
};

export default class SendButton extends React.Component {
  chooseAPI = () => {
    switch (this.props.type) {
      case "Email":
        sendEmail(this.props.val, this.props.url, this.props.changes, this.props.confirmHandler);
        break;
      case "Text":
        sendText(this.props.val, this.props.url, this.props.changes, this.props.confirmHandler);
        break;
      default:
    }
  };
  render() {
    return (
      <Button
        variant="outlined"
        onClick={this.chooseAPI.bind(this)}
        color="primary"
      >
        <span>
          {this.props.name}
        </span>
      </Button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/NavBar/SendDialog/SendButton.js